import script from "./StrategyHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./StrategyHeader.vue?vue&type=script&setup=true&lang=ts"

import "./StrategyHeader.vue?vue&type=style&index=0&id=09aceede&scoped=true&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09aceede"]])

export default __exports__